import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from './router';
import store from './store';
import request from './utils/request';
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

Vue.config.productionTip = false

Vue.prototype.$http = request;
Vue.prototype.$moment = moment;


Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
